import type { AlpineComponent } from 'alpinejs';

type Entry = {
	id: number;
    image_id: string;
	src: string;
};

export const productImages: AlpineComponent = {
	value: {} as Record<number, Entry>,

	push(entry: Entry) {
		this.value[entry.image_id] = entry;
	}
};
